/* eslint-disable no-restricted-syntax */
export const DEFAULT_ROUTE = 'default';
const DEFAULT_ROUTE_PATTERN = '/';

export const SIGNUP_ROUTE = 'signup';
const SIGNUP_ROUTE_PATTERN = '/signup';

export const NOT_FOUND_ROUTE = 'notFound';
const NOT_FOUND_ROUTE_PATTERN = '/not-found';

export const RAMP_CONTEXT = 'ramp';
export const DRUPAL_ACCOUNT_ROUTE = '/account/index.tmpl';
export const DRUPAL_ACCOUNT_FORGOT_PASSWORD = '/account/password_request.tmpl';

export const QRCODE_ROUTE = 'thankyou';
const QRCODE_ROUTE_PATTERN = '/thankyou';

export interface IRoutes {
    signup: string;
    qrcode: string;
}

export const defaultAppRoutes = {
    signup: '/signup',
    qrcode: '/thankyou'
};
export const getAppRoutes = (routes: IRoutes = defaultAppRoutes) => {
    return [
        {
            name: DEFAULT_ROUTE,
            pattern: DEFAULT_ROUTE_PATTERN,
            context: RAMP_CONTEXT
        },
        {
            name: SIGNUP_ROUTE,
            pattern: SIGNUP_ROUTE_PATTERN,
            location: routes.signup,
            context: RAMP_CONTEXT
        },
        {
            name: QRCODE_ROUTE,
            pattern: QRCODE_ROUTE_PATTERN,
            location: routes.qrcode,
            context: RAMP_CONTEXT
        },
        {
            name: NOT_FOUND_ROUTE,
            pattern: NOT_FOUND_ROUTE_PATTERN
        }
    ];
};
